var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('el-select',{staticClass:"header-buttom",attrs:{"value":_vm.selectedSchoolYear,"size":"medium","placeholder":"请选择学期"},on:{"change":_vm.onSchoolYearChange}},_vm._l((_vm.schoolYearList),function(item){return _c('el-option',{key:item.year,attrs:{"label":item.year,"value":item.year}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f9ca959","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SchoolYearSelector/index.vue
// module id = null
// module chunks = 